function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworkIcon = function SvgNetworkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.586,
    height: 27.594,
    viewBox: "0 0 17.088 7.301"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M109.347 144.85c-.773 0-1.413.262-1.994.594a3.65 3.65 0 0 0-1.656 3.056c0 1.071.5 1.887.999 2.644.76.5 1.58 1.006 2.651 1.006 1.262 0 2.375-.64 3.03-1.614.345-.593.62-1.246.62-2.036q0-.19-.018-.374a3.65 3.65 0 0 0-3.632-3.276m-.317 1.422h.945v1.819h1.836v.923h-1.836v1.82h-.945v-1.82h-1.836v-.923h1.836z",
    clipPath: "url(#network-icon_svg__clipPath32502)",
    style: {
      opacity: 0.5,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.352778
    },
    transform: "translate(-95.91 -144.85)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#network-icon_svg__clipPath25249-4)",
    style: {
      fill: "#fff"
    },
    transform: "matrix(.35278 0 0 -.35278 5.691 .623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.685.982-3.539 1.766-5.785 1.766-5.357 0-9.763-4.071-10.293-9.288a10 10 0 0 1-.054-1.058c0-2.192.743-4.004 1.685-5.65 1.847-2.826 5.034-4.698 8.662-4.698 3.038 0 5.35 1.421 7.496 2.831 1.417 2.158 2.853 4.478 2.853 7.517C4.564-5.008 2.753-1.859 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#network-icon_svg__clipPath32542)",
    style: {
      opacity: 0.5,
      fill: "#fff",
      fillOpacity: 1
    },
    transform: "matrix(.35278 0 0 -.35278 -44.913 46.824)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.879-1.648-5.247-3.91-8.219-3.91-2.923 0-5.271 2.191-8.088 3.83a10.34 10.34 0 0 0 4.564-8.58c0-3.039-1.436-5.359-2.853-7.517 2.111 1.389 4.06 2.766 6.377 2.766 2.306 0 4.254-1.364 6.356-2.744-1.41 2.145-2.832 4.457-2.832 7.495C-4.695-5.034-2.824-1.848 0 0",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(159.753 131.042)"
  }))));
};
export default SvgNetworkIcon;